import { JSEncrypt } from 'jsencrypt';
import * as CryptoJS from 'crypto-js';

function RndNum(n) {
  var rnd = '';
  for (var i = 0; i < n; i++) {
    rnd += Math.floor(Math.random() * 10);
  }
  return rnd;
};

function Encrypt(word, randomStr) {
  const key = CryptoJS.enc.Utf8.parse(randomStr);
  const srcs = CryptoJS.enc.Utf8.parse(word);
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

const getEncryption = (params) => {
  const servicePublicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDSF464wZRt9ALjBeAOjZ54Racbb6vuilFppTbKqDO0a8b9hDXK1b0YBZvHtaUq1G/v7fXs9lchiQfJH/EpcdEjkweKXzANjeyoiPEsE/vB5k6Wz6f83vYLw99olnanlP5PlRcLsQFX+LiDslx4xT/UUmgJaXblrs/gLlYuMrzYnwIDAQAB';
  const randomStr = RndNum(16);
  const data = Encrypt(JSON.stringify(params), randomStr);
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(servicePublicKey);
  const encrypted = encrypt.encrypt(randomStr);
  // 创建json对象
  const json = {
    'requestData': data,
    'encrypted': encrypted
  };
  return JSON.stringify(json)
}

export default getEncryption